import axios from "axios";
import Popover from "react-bootstrap/Popover";
import Image from "react-bootstrap/Image";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import "./css/map.css";
import {Server} from "../../constants";

function ConcesionarioPoint({
  color,
  name,
  codigo,
  setCiudad,
  setLatitud,
  setLongitud,
  setZoom,
  tipo,
  concesionarios,
  setConcesionarios,
  setConcesionario,
  setConcesionarioc,
  empresa,
  empresaNombre,
  telefono,
  contacto,
  email,
  telefono_con,
  imagen,
}) {
  const popInfo = (empresaNombre, name, contacto, telefono, email, imagen) => {
    let imgpop = require(`../../images/concesionario/taller/${imagen}`);
    return (
      <Popover className="popover-ventas">
        <Popover.Title>
          {empresaNombre}/{name}
        </Popover.Title>
        <Popover.Content>
          <Image src={imgpop} alt={name} fluid />
          <p className="mt-2">
            <strong>Jefe de Taller: </strong>
            {contacto}
          </p>
          <p>
            <strong>Teléfono: </strong>
            {telefono_con}
          </p>
          <p>
            <strong>Email: </strong>
            {email}
          </p>
        </Popover.Content>
      </Popover>
    );
  };

  const handleClick = (codigo, empresa) => {
    if (tipo === "ciudad") {
      if (codigo !== 100) {
        const getCiudadMapa = async () => {
          const url = `${Server}/api/ciudad_mapa/${codigo}`;
          const resultado = await axios.get(url);
          setCiudad(resultado.data[0].CIU_CODIGO);
          setLatitud(resultado.data[0].CIU_LATITUD);
          setLongitud(resultado.data[0].CIU_LONGITUD);
          setZoom(resultado.data[0].CIU_ZOOM);
        };
        getCiudadMapa();
        const getConcesionariosPoint = async () => {
          const url = `${Server}/api/concesionarios_point_talleres/${codigo}/2-3`;
          const resultado = await axios.get(url);
          setConcesionarios(resultado.data);
        };
        getConcesionariosPoint();
      } else {
        setCiudad(100);
        setLatitud(-1.8798743);
        setLongitud(-78.6103923);
        setZoom(7);
      }
    } else {
      const s = [];
      const ss = [];
      // Concesionario
      concesionarios.forEach(function (number, i) {
        let idC =
          concesionarios[i].ALM_EMPRESA + "/" + concesionarios[i].ALM_CODIGO;
        if (
          concesionarios[i].ALM_EMPRESA === empresa &&
          concesionarios[i].ALM_CODIGO === codigo
        ) {
          s.push(concesionarios[i]);
          document.getElementById(idC).className = "agencia-active";
          // Spreed Operator
          ss.push(concesionarios[i]);
        } else {
          document.getElementById(idC).className = "card";
        }
      });
      concesionarios.forEach(function (number, i) {
        if (
          concesionarios[i].ALM_EMPRESA !== empresa ||
          concesionarios[i].ALM_CODIGO !== codigo
        ) {
          s.push(concesionarios[i]);
        }
      });
      let cons = empresa + "/" + codigo;
      setConcesionarios(s);
      setConcesionario(cons);
      setConcesionarioc(ss);
    }
  };

  return tipo === "ciudad" ? (
    <div
      className="pin bounce"
      style={{ backgroundColor: color, cursor: "pointer" }}
      title={name}
      onClick={() => {
        handleClick(codigo, empresa);
      }}
    ></div>
  ) : (
    <div>
      <OverlayTrigger
        placement="top"
        delay={{ show: 200, hide: 200 }}
        overlay={popInfo(
          empresaNombre,
          name,
          contacto,
          telefono,
          email,
          imagen
        )}
      >
        <div
          className="pin bounce"
          style={{ backgroundColor: color, cursor: "pointer" }}
          onClick={() => {
            handleClick(codigo, empresa);
          }}
        ></div>
      </OverlayTrigger>
      <div className="pulse" />
    </div>
  );
}
export default ConcesionarioPoint;